<style lang="scss">
.v-application {
  &.cityads {
    font-family: 'Open Sans' !important;
    font-weight: normal;
    // width: 1515px;
    margin: 0 auto;
  }
}
</style>

<template>
  <v-app  :class="$widgetType" :style="style">
    <!-- <DebugMenu/> -->
    <v-main>
      <Modal :value="$modals.active" />

      <div :class="$forms.active" class="container pt-10">
        <Form :value="$forms.active" />

        <!-- <Phone /> -->
      </div>
    </v-main>
  </v-app>
</template>

<script>
// import DebugMenu from '@/components/controls/Debug/DebugMenu.vue';
import Form from './components/Form';
// import Phone from "./components/controls/Phone";
import Modal from "./components/Modal";


export default {
  name: 'App',
  components: {
    // DebugMenu,
    Modal,
    // Phone,
    Form,
  },
  mounted() {
    this.$forms.open('Main');
    // this.$forms.open('Passport');
    // this.$forms.open('Additional');
    // this.$modals.open('Link');
  },
  computed: {
    style() {
      let width = {
        'xs': 450,
        'sm': 768,
        'md': 945,
        'lg': 1146,
        'xl': 1514
      }

      return { 
        width: (width[this.$vuetify.breakpoint.name] || 1514) + "px" ,
        margin: '0 auto'
      };
    }
  }

};
</script>
